var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystoreLightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.2917V1.125C0 0.633333 0.283333 0.2 0.7 0L8.90833 8.20833L0.7 16.4167C0.283333 16.2083 0 15.7833 0 15.2917ZM11.5083 10.8083L2.54167 15.9917L9.61667 8.91667L11.5083 10.8083ZM14.3 7.21667C14.5833 7.44167 14.7917 7.79167 14.7917 8.20833C14.7917 8.625 14.6083 8.95833 14.3167 9.19167L12.4083 10.2917L10.325 8.20833L12.4083 6.125L14.3 7.21667ZM2.54167 0.425L11.5083 5.60833L9.61667 7.5L2.54167 0.425Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystoreLightIcon);
export default __webpack_public_path__ + "static/media/play store Light Icon.0b0f537c2d56405c596c25adae15aed1.svg";
export { ForwardRef as ReactComponent };